import React, {useContext} from 'react';
import {Prices} from "./components/Prices";
import {StockDot} from "../../common/StockDot";
import {ProductContext} from "../../../../pages/ProductStencil";
import {GetPackagingItem} from "../../../../../interfaces/ecom/schema";

interface IProps {
    item: GetPackagingItem,
    index: number
}

export const MultiSKU = ({enabled}) => {
    const {Packaging, activeProductIndex, setActiveProduct, SapDetails} = useContext(ProductContext);

    const handleSelect = (MaterialNumber: string) => {
        setActiveProduct(MaterialNumber);
    }

    const MultiSkuItem = ({item, index}: IProps) => {
        const {MaterialNumber, StockType} = item;

        return (<div
            className={
                `
                multi-sku__option 
                ${index === activeProductIndex ? 'multi-sku__option--selected' : ''} 
                ${StockType === "BLOCKSALE" ? 'multi-sku__option--blocksale' : ''}
            `
            }
            key={index}
            role={"button"}
            tabIndex={0}
            aria-label={`Select ${SapDetails[index]?.Packaging} option`}
            aria-checked={index === activeProductIndex}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    handleSelect(MaterialNumber);
                }
            }}

            onClick={() => {
                handleSelect(MaterialNumber)
            }}
        >
            <p className={'multi-sku__option-size'}>{SapDetails[index]?.Packaging}</p>
            {(enabled && !item.IsObsolete && item.HasPrice) &&
              <>
                <Prices data={item}/>
                <StockDot stockType={StockType}/>
              </>
            }
        </div>)
    }

    return (
        <div className={"multi-sku"}>
            {Packaging
                .map((item, index) => MultiSkuItem({item, index}))}
        </div>
    );
}
